import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-ignore
import traverseISODate from '@segment/isodate-traverse';
export const buildContext = context => {
  return _objectSpread(_objectSpread({}, context.context), {}, {
    userAgent: navigator.userAgent
  });
};
export const prepareEventProperties = properties => {
  const propertiesWithoutUndefined = nestedRemoveUndefinedValues(properties);
  return traverseISODate(propertiesWithoutUndefined);
}; // This function will essentially deepClone as well

export const nestedRemoveUndefinedValues = obj => {
  const clone = {};
  Object.keys(obj).forEach(key => {
    const value = getValueOfObject(obj, key);

    if (value !== undefined) {
      if (Array.isArray(value)) {
        clone[key] = value.map(i => i);
      } else if (typeof value === 'object' && value !== null) {
        clone[key] = nestedRemoveUndefinedValues(value);
      } else {
        clone[key] = value;
      }
    }
  });
  return clone;
}; // Using ts-ignore everywhere urked me

const getValueOfObject = (obj, key) => {
  // @ts-ignore This is an object
  return obj[key];
};
/*
 * Segments new Analytics-next client will store strings as strings without stringifing.
 * The legacy Segment client and AWC always stringify and parse cookies and values.
 * If the new Segment analytics-client stores a cookie and local storage value first, it will
 * breaking old clients.
 */


export const safeJSONParse = value => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};